export const showInvoiceDetailDialog = ({ commit }, showValue) => {
  commit('setInvoiceDetailDialog', showValue);
};

export const showPrintConfirmDialog = ({ commit }, showValue) => {
  commit('setShowPrintConfirmDialog', showValue);
};

export const setItemToShow = ({ commit }, item) => {
  commit('setItemDetailsDialogItem', item);
};

export const showSuccessModal = ({ commit }, showValue) => {
  commit('setSuccessModal', showValue);
};

export const setSuccessMessage = ({ commit }, successMessage) => {
  commit('setSuccessModalMessage', successMessage);
};
export const showNavDatePickerModal = ({ commit }, showValue) => {
  commit('setNavDatePickerModal', showValue);
};

export const showLoadingIndicator = ({ commit }, showValue) => {
  commit('setLoadingIndicator', showValue);
};

export const registerUnauthNavAttempt = ({ commit }, routerUrlPayload) => {
  commit('setUnauthNavAttemptUrl', routerUrlPayload);
};

export const logUserIn = ({ commit }, user) => {
  commit('setCurrentUser', user);
};

export const logUserOut = ({ commit }) => {
  commit('setCurrentUser', null);
};

export const createUser = ({ commit }) => {
  commit('addUser');
};
export const fetchCategorias = ({ commit }, categoryasPayload) => {
  commit('setCategorias', categoryasPayload);
};
export const fetchServicesAll = ({ commit }, serviciosPayload) => {
  commit('setServicios', serviciosPayload);
};
export const fetchProductsAll = ({ commit }, productosPayload) => {
  commit('setProductos', productosPayload);
};

export const toggleChargeBillModal = ({ commit }, payload) => {
  commit('setChargeBillModalStatus', payload);
};

export const toggleEntregarServicioModal = ({ commit }, payload) => {
  commit('setEntregarServicioModalStatus', payload);
};

export const addInvoiceToCharge = ({ commit }, payload) => {
  commit('setInvoicesToCharge', payload);
};

export const notifyNewClientAdded = ({ commit }, clientID) => {
  commit('setNewClientAdded', clientID);
};